"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteProductTreeNode = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useDeleteProductTreeNode = () => {
    const [deleteProductTreeNodeMutation, data] = (0, react_2.useMutation)(gql_1.DELETE_PRODUCT_TREE_NODE);
    const deleteProductTreeNode = (0, react_1.useCallback)((...args) => deleteProductTreeNodeMutation(...args), [deleteProductTreeNodeMutation]);
    return Object.assign({ deleteProductTreeNode }, data);
};
exports.useDeleteProductTreeNode = useDeleteProductTreeNode;
